<template>
  <div class="update_mfa_area container-fluid">
    <div class="row">
      <div class="col text-center">
        <h1>Multi-Factor Authentication</h1>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <p style="color: #183961">
          To finish setting up MFA for your account, please enter your email
          address and cell phone number below.
        </p>
      </div>
    </div>

    <div class="py-5 px-3">
      <div class="form-group row pb-3">
        <label
          for="inputEmail"
          class="col-small-3 col-form-label align-self-center"
        >
          Email
        </label>
        <div class="col-small-9 align-self-center">
          <input
            type="email"
            class="form-control"
            id="inputEmail"
            placeholder="Email"
            v-model="email"
            v-on:input="validateEmail()"
            @keypress="checkEnter"
          />
        </div>
      </div>

      <div class="form-group row pb-3">
        <label
          for="inputPhone"
          class="col-small-3 col-form-label align-self-center"
        >
          Phone Number
        </label>
        <div class="col-small-9 align-self-center">
          <BaseInput
            v-model="phone"
            id="inputPhone"
            type="tel"
            mask="phone"
            placeholder="Phone number"
            class="form-control"
            @keypress="checkEnter"
          />
        </div>
      </div>

      <div class="row">
        <div class="col pb-3">
          <p class="my-0 error-message">{{ this.email_message }}</p>
          <p class="my-1 error-message">{{ this.phone_message }}</p>
          <p
            class="my-1"
            :class="has_error ? 'error-message' : 'success-message'"
          >
            {{ this.message }}
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <button
          type="button"
          :disabled="
            email_has_error || phone_has_error || is_loading ? true : false
          "
          :class="
            email_has_error || phone_has_error || is_loading
              ? 'button-gray-small'
              : 'button-green'
          "
          class="btn px-5"
          v-on:click="saveMFAInfo()"
        >
          <template v-if="is_loading">
            <div class="row">
              <div class="col-auto align-self-center">
                <small style="font-weight: bold">Saving...</small>
              </div>
              <div class="col-auto align-self-center">
                <img
                  style="max-width: none"
                  class="img-responsive"
                  src="\images\analysis-loading-gif.svg"
                  title="Saving MFA"
                />
              </div>
            </div>
          </template>
          <template v-else>Enable</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseInput from '~/components/base/BaseInput.vue';
  export default {
    name: 'UpdateMFAComponent',
    components: {
      BaseInput,
    },
    props: {
      mfa_info: {
        type: Object,
        default() {
          return {
            email: '',
            phone: '',
          };
        },
      }, // user mfa object
    },

    data: function () {
      return {
        is_loading: false,
        has_error: false,
        message: '',

        email: this.mfa_info.email ?? '',
        email_has_error: false,
        email_message: '',

        phone: this.mfa_info.phone ?? '',
        phone_has_error: false,
        phone_message: '',
      };
    },

    mounted() {
      $('#modal_mfa_setup').on('hide.bs.modal', () => {
        if (!this.email) {
          this.email = this.mfa_info.email;
        }
        if (!this.phone) {
          this.phone = this.mfa_info.phone;
        }
      });
    },

    methods: {
      checkEnter(event) {
        if (event.key === 'Enter') {
          this.saveMFAInfo();
        }
      },
      saveMFAInfo: function () {
        this.message = '';
        this.has_error = false;
        this.is_loading = true;

        if (!this.email && !this.phone) {
          this.message = 'Please fill out one or both fields';
          this.has_error = true;
          this.is_loading = false;
        } else {
          axios
            .post('/api/v1/user/mfa/update', {
              email: this.email,
              phone: this.phone,
            })
            .then((success) => {
              this.message = success.data.message;
              this.has_error = !success.data.success;
              this.is_loading = false;

              // wait 1 second then close if success
              if (success.data.success) {
                setTimeout(() => {
                  this.message = '';
                  this.$emit('close');
                }, 1000);
              }
            })
            .catch((error) => {
              this.has_error = true;
              this.is_loading = false;
              this.message =
                'Error trying to save data. Please contact support.';
            });
        }
      },
      validateEmail() {
        this.message = ''; // reset
        if (this.email) {
          // if we have a value run validation checks
          if (
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
          ) {
            this.email_has_error = false;
            this.email_message = '';
          } else {
            this.email_has_error = true;
            this.email_message = 'Please enter a valid email address';
          }
        } else {
          this.email_has_error = false;
          this.email_message = '';
        }
      },
      validatePhone() {
        //leaving this here in case it one day needs to be validated
        const phoneRegex =
          /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?[\d\s.-]{7,}$/;
        return phoneRegex.test(this.phone);
      },
    },
  };
</script>
